import PropTypes from 'prop-types';

import { providers } from '@febos-io/design';

import NavbarOption from './NavbarOption';
import NavbarDropdownOptions from './NavbarDropdownOptions';
import useTranslation from '../hooks/useTranslation';
import HasPermission from './HasPermission';

export function Sidebar(
  {
    title,
    config = [],
    children,
    i18nNamespace
  }
) {
  const { AppLogo } = providers.useDesignContext();
  const { t } = useTranslation(i18nNamespace);
  return (
    <div
      className="d-flex flex-column flex-shrink-0 p-3 bg-light vh-100 sticky-top"
      style={{ width: '220px' }}
    >
      <a
        href="/"
        className="d-flex align-items-center mb-3 mb-md-0 me-md-auto link-dark text-decoration-none"
      >
        {AppLogo && <AppLogo className="bi me-2" />}
        <span className="fs-4 fw-semibold">{t(title)}</span>
      </a>
      <ul className="nav nav-pills flex-column mb-auto">
        {config.map((item) => (
          item.to ? (
            <HasPermission
              key={item.text}
              roles={item.roles}
            >
              <NavbarOption
                className="nav-item"
                text={item.text}
                icon={item.icon}
                to={item.to}
                i18nNamespace={i18nNamespace}
              />
            </HasPermission>
          ) : (
            <HasPermission
              key={item.text}
              roles={item.roles}
            >
              <NavbarDropdownOptions
                text={item.text}
                icon={item.icon}
                options={item.options}
                i18nNamespace={i18nNamespace}
              />
            </HasPermission>
          )
        ))}
      </ul>
      <hr />
      {children}
    </div>
  );
}

Sidebar.propTypes = {
  title: PropTypes.string.isRequired,
  config: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    to: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      to: PropTypes.string.isRequired
    }))
  })).isRequired,
  children: PropTypes.node,
  i18nNamespace: PropTypes.string
};

export default Sidebar;
